export class ProductSold {
  constructor(
    public product_id: number,
    public price: number
  ) { }
}
